module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-invitation-9df0bff7459aff6a720b36e2a289c111.jpg";